import React, { Component } from 'react';
import { Button, CircularProgress, Tooltip } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import UsageService from '../../services/usage.service';
import { toCsv, downloadCsv, csvFileName, MAX_EXPORT_ROWS } from './usage-csv';
import { t } from './usage-i18n';

// ---------------------------------------------------------------------------
// Botão "Exportar CSV" padrão das abas de uso. Exporta o RECORTE ATUAL (mesmos filtros da tela), até MAX_EXPORT_ROWS.
//   tab      — nome curto da aba/bloco (vai no nome do arquivo e no registro da exportação)
//   columns  — [{ header, value: (row) => any }]
//   getRows  — () => rows | Promise<rows> | Promise<{ rows, total, truncated }>  (fetchAllPages devolve o terceiro formato)
//   filters  — objeto com o recorte (vira texto no registro da exportação; nada de nome/e-mail)
//   onNotify — (variant, message) opcional, para o aviso de "truncado" / erro
// Exportar dado de AUDITORIA também é auditado: depois do download, avisa o Reports (export/mark), que grava um evento
// 'export' com a aba, a quantidade e o recorte. Falha nesse aviso não impede o download.
// ---------------------------------------------------------------------------

export default class UsageExportButton extends Component {
  constructor(props) {
    super(props);
    this.state = { busy: false };
    this.run = this.run.bind(this);
  }

  componentWillUnmount() { this.gone = true; }

  run() {
    if (this.state.busy) return;
    const { intl, tab, columns, getRows, filters, onNotify } = this.props;
    this.setState({ busy: true });
    Promise.resolve()
      .then(() => getRows())
      .then((res) => {
        const rows = Array.isArray(res) ? res : ((res && res.rows) || []);
        const truncated = !Array.isArray(res) && !!(res && res.truncated);
        const total = Array.isArray(res) ? rows.length : ((res && res.total) || rows.length);
        if (!rows.length) { if (onNotify) onNotify('info', t(intl, 'usage.export.empty', 'Nada para exportar com esses filtros.')); return; }
        downloadCsv(csvFileName(tab), toCsv(columns, rows));
        UsageService.exportMark({ tab, rows: rows.length, total, filters: JSON.stringify(filters || {}).slice(0, 1500) });
        if (truncated && onNotify) onNotify('info', `${t(intl, 'usage.export.truncated', 'Exportadas as primeiras')} ${rows.length.toLocaleString('pt-BR')} ${t(intl, 'usage.export.of', 'de')} ${Number(total).toLocaleString('pt-BR')}. ${t(intl, 'usage.export.narrow', 'Refine o filtro ou o período para levar o restante.')}`);
      })
      .catch((err) => { if (onNotify) onNotify('error', (err && err.message) || t(intl, 'usage.export.fail', 'Falha ao exportar.')); })
      .then(() => { if (!this.gone) this.setState({ busy: false }); });
  }

  render() {
    const { intl, disabled } = this.props;
    const { busy } = this.state;
    return (
      <Tooltip title={`${t(intl, 'usage.export.tip', 'Exporta o recorte atual desta lista em CSV (separador ;). Limite:')} ${MAX_EXPORT_ROWS.toLocaleString('pt-BR')} ${t(intl, 'usage.export.rows', 'linhas')}.`}>
        <span>
          <Button size="small" variant="outlined" disabled={busy || !!disabled} onClick={this.run}
            startIcon={busy ? <CircularProgress size={14} /> : <FileDownloadIcon fontSize="small" />} style={{ textTransform: 'none', whiteSpace: 'nowrap' }}>
            {t(intl, 'usage.export.csv', 'Exportar CSV')}
          </Button>
        </span>
      </Tooltip>
    );
  }
}
